import { h } from 'preact';
import PropTypes from 'prop-types';

import { getSvgImgSrc } from '../../../utils/string-utils';
import { modifierList as iconsModifiersList } from '../../components/1-foundation/icons/props-list';
import SlimBannerBottomComponent from '../../components/4-organisms/slim-banner-bottom/slim-banner-bottom';
import { BANNER_BOTTOM_WPN_STATUS, setStatusOnLocalStorage } from '../../../utils/local-storage';
import { useToggleBannerBottomWPN, useWithBannerBottom } from '../../hooks/use-banner-bottom';
import { getHandlers } from '../auto-push-notifications/getters/get-handlers';
import {
  autoPushNotificationsActions,
  autoPushNotificationsStore,
} from '../../../global-store/subjects/auto-push-notifications';
import { useSubscribe } from '../../hooks/use-subscribe';
import {
  slimBannerBottomActions as actions,
  slimBannerBottomStore,
} from '../../../global-store/subjects/slim-banner-bottom/slim-banner-bottom';
import { satelliteTracker } from '../../../services/tracking/satellite-tracking-service';

const BANNER_MODIFIERS = ['slim'];

const SlimBannerBottomWPN = ({ widget, htmlProps, selectBoxes }) => {
  const pushNotificationsState = useSubscribe(autoPushNotificationsStore);
  const WPNHandlers = getHandlers({ state: pushNotificationsState, actions: autoPushNotificationsActions });
  const state = useSubscribe(slimBannerBottomStore);

  // CUSTOM HOOKS
  useToggleBannerBottomWPN({ actions, pushNotificationsState });
  useWithBannerBottom({ state });

  // UTILS/HANDLERS
  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    satelliteTracker.trackInWeb('slimBannerBottom_CTA');
    WPNHandlers.handleWPNAccept(selectBoxes);
    if (BANNER_BOTTOM_WPN_STATUS.OK) {
      setStatusOnLocalStorage({
        key: BANNER_BOTTOM_WPN_STATUS.OBJECT_KEY,
        name: BANNER_BOTTOM_WPN_STATUS.OK.NAME,
        expirationDays: BANNER_BOTTOM_WPN_STATUS.OK.EXPIRATION_DAYS,
      });
    }
    actions.hideBannerBottom();
  };

  const handleClose = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setStatusOnLocalStorage({
      key: BANNER_BOTTOM_WPN_STATUS.OBJECT_KEY,
      name: BANNER_BOTTOM_WPN_STATUS.KO.NAME,
      expirationDays: BANNER_BOTTOM_WPN_STATUS.KO.EXPIRATION_DAYS,
    });
    satelliteTracker.trackInWeb('generic_interaction', { interaction_name: 'slimBannerBottomWPN-closed' });
    actions.hideBannerBottom();
  };

  if (state.showBanner === undefined) {
    return null;
  }

  if (state.showBanner) {
    const sectionDividerModifiers = state.showBanner ? ['fixed-bottom'] : ['fixed-bottom', 'slide-out'];
    return (
      <SlimBannerBottomComponent
        href={htmlProps.standardLinkCTA}
        modifiers={BANNER_MODIFIERS}
        isWrapping
        target={htmlProps.target}
        onClick={handleClick}
        onClose={handleClose}
        sectionDividerModifiers={sectionDividerModifiers}
        imgSrc={getSvgImgSrc(htmlProps.standardLogo)}
        text={htmlProps.standardTextCTA}
        iconsColor={widget.styles.iconsColor}
      />
    );
  }
};

SlimBannerBottomWPN.propTypes = {
  htmlProps: PropTypes.shape({
    target: PropTypes.string,
    standardLogo: PropTypes.string,
    standardTextCTA: PropTypes.string,
    standardLinkCTA: PropTypes.string,
  }),
  widget: PropTypes.shape({
    styles: PropTypes.shape({
      iconsColor: PropTypes.oneOf(iconsModifiersList).isRequired,
    }),
  }),
};

export default SlimBannerBottomWPN;
